import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import DateAndTime from "./DateAndTime.js";
const DateAndTimeContainer = ({ date, startTime, duration, ...rest }) => {
  const {
    getLabel,
    dateTime: { formatLongDate, formatTime }
  } = useIntl();
  const durationLabel = duration ? duration.amount > 0 ? ` (${duration.amount} ${getLabel(
    `appointments.shortTimeUnits.${duration.unit.toLowerCase()}`
  )})` : "" : "";
  const formattedDate = React.useMemo(() => {
    if (date) {
      return `${formatLongDate(date)} ${durationLabel}`;
    }
  }, [date, durationLabel, formatLongDate]);
  const formattedTime = React.useMemo(() => {
    if (startTime) {
      return formatTime(startTime);
    }
  }, [startTime, formatTime]);
  return /* @__PURE__ */ React.createElement(DateAndTime, { ...rest, formattedDate, formattedTime });
};
export {
  DateAndTimeContainer as default
};
//# sourceMappingURL=DateAndTimeContainer.js.map
